import { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DESKTOP_DATA, MOBILE_DATA } from "../utils/data.js";

const toCssSize = (v) => (typeof v === "number" ? `${v}px` : v);

const HorizontalScrolling = ({
  itemWidth = 240,
  gap = 16,
  cardHeight = 300,
}) => {
  const scrollRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const isMobile = windowWidth <= 768;
  const displayItems = isMobile ? MOBILE_DATA : DESKTOP_DATA;

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="hs-container">
      <h3 className='mb-3 text-header text-center'>แนะนำการเข้าใช้งาน</h3>
      <div 
        ref={scrollRef} 
        className="hs-scroll"
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          scrollSnapType: "x mandatory",
          paddingBottom: windowWidth < 768 ? 4 : 8,
          paddingLeft: windowWidth < 768 ? 8 : 0,
          paddingRight: windowWidth < 768 ? 8 : 0,
          scrollbarWidth: windowWidth < 768 ? "none" : "auto",
          msOverflowStyle: windowWidth < 768 ? "none" : "auto",
        }}
      >
        <div className="content-box" style={{ 
          gap,
          display: "flex",
          flexDirection: windowWidth <= 768 ? "column" : "row",
          alignItems: windowWidth <= 768 ? "center" : "flex-start",
          flexWrap: "nowrap",
          justifyContent: "flex-start",
        }}>
          {displayItems.map((item) => {
            // ตรวจสอบว่าเป็น mobile หรือไม่
            const isMobile = windowWidth <= 768;
            
            // เลือก width ตาม device จาก data.js
            const w = isMobile
              ? (item.widthmobileImg ?? item.mobileWidth ?? item.cardWidth ?? item.width ?? itemWidth)
              : (item.widthimg ?? item.cardWidth ?? item.width ?? itemWidth);

            const h = item.cardHeight ?? cardHeight;
            
            // เลือก image ตาม device
            const imageSrc = isMobile && item.mobileImg ? item.mobileImg : item.img;

            return (
              <div
                key={item.id}
                className="card"
                style={{
                  "--card-w": toCssSize(w),
                  "--card-h": toCssSize(h),
                  width: toCssSize(w),
                  height: toCssSize(h),
                  minWidth: isMobile ? "80vw" : toCssSize(w),
                  maxWidth: isMobile ? "90vw" : "100%",
                  minHeight: isMobile ? "200px" : toCssSize(h),
                  borderRadius: isMobile ? 0 : 0,
                  boxShadow: isMobile ? "none" : "none",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: "0 0 auto",
                }}
              >
                <img
                  src={imageSrc}
                  alt={`item-${item.id}`}
                  loading="lazy"
                  draggable={false}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    display: "block",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

HorizontalScrolling.propTypes = {
  itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gap: PropTypes.number,
  cardHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default HorizontalScrolling;
